import Modal from '../modal/modal';
import Card from '../card/Card';
import P from '../texts/p/P';
import Span from '../texts/span/Span';
import { Share } from '../../types/interfaces';

export interface ShareDisableConfirmModalProps {
  isOpen: boolean;
  share: Share | null;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const formatIssuedQuantity = (value: number | null | undefined): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return value.toLocaleString('es-AR');
};

const Field = ({ label, value }: { label: string; value: string | null | undefined }) => (
  <div>
    <Span type='2' weight='bold' variant='neutral' modifier='strong'>
      {label}
    </Span>{' '}
    <Span type='2' weight='regular' variant='neutral' modifier='regular'>
      {value ?? '—'}
    </Span>
  </div>
);

const ShareDisableConfirmModal = ({
  isOpen,
  share,
  onConfirm,
  onCancel,
  isLoading = false,
}: ShareDisableConfirmModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title='¿Dar de baja la acción?'
      width='544px'
      primaryText='Dar de baja'
      primaryVariant='danger'
      onPrimaryAction={onConfirm}
      primaryActionDisabled={isLoading}
      loadingPrimaryBtn={isLoading}
      secondaryText='Cancelar'
      secondaryVariant='contained'
      onSecondaryAction={onCancel}
      showOverlay={true}
    >
      <Card margin={{ top: '3', bottom: '3' }}>
        <P type='2' variant='neutral' weight='regular' modifier='regular' withMargin={false}>
          La acción deja de estar disponible pero no se elimina: se puede reactivar después.
        </P>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 24px', marginTop: '16px' }}>
          <div style={{ gridColumn: '1 / -1' }}>
            <Field label='Nombre:' value={share?.name} />
          </div>
          <Field label='Ticker:' value={share?.ticker} />
          <Field label='Tipo:' value={share?.shareTypeName} />
          <Field label='Cantidad emitida:' value={formatIssuedQuantity(share?.issuedQuantity)} />
          <Field label='Moneda:' value={share?.currencyDescription} />
        </div>
      </Card>
    </Modal>
  );
};

export default ShareDisableConfirmModal;
